import React, {useEffect, useState} from 'react';
import './CaseDetailPage.scss';
import {useSelector} from "react-redux";
import {SwitchUser} from "../../../helpers/helpers";
import {UserRoleEnum} from "../../../helpers/enums";
import {client} from "../../../App";
import {GET_CUSTOMER_CASES, GET_OPERATOR_CASES} from "../../../helpers/queries";
import CaseGenerator from "../../CaseGenerator/CaseGenerator";
import Modal from "../../common/Modal/Modal";
import {useHistory, Link} from "react-router-dom";
import {useTranslation} from "react-i18next";
import Loader from "../../common/Loader/Loader";
import digitalizzazioneCustomModalSuccess
  from "../../CaseGenerator/custom-success-modal/digitalizzazioneCustomModalSuccess";

const CaseDetailPage = props => {
  const user = useSelector((state) => state.auth);
  const userProfile = SwitchUser(user);
  const {role} = userProfile;

  const [loading, setLoading] = useState(false);
  const [caseDetails, setCaseDetails] = useState(null);

  const paramsMatch = props.match || props.computedMatch;
  const {params} = paramsMatch;
  const {caseId} = params;
  const history = useHistory();
  const {t} = useTranslation();

  const getCorrectQueryForUser = (type) =>
    (role !== UserRoleEnum.MUNICIPAL_OPERATOR) ?
      client().query({
        query: GET_CUSTOMER_CASES
      }) :
      client().query({
        query: GET_OPERATOR_CASES
      });

  const getCaseDetail = (caseId) => {
    return new Promise((resolve, reject) => {
      const query = getCorrectQueryForUser(role);
      return query
        .then(result => {
          const correctMutation =
            (role !== UserRoleEnum.MUNICIPAL_OPERATOR) ? 'getCustomer' : 'getOperator';

          if (result.data &&
            result.data[correctMutation] &&
            result.data[correctMutation].cases &&
            result.data[correctMutation].cases.elements) {

            const {elements: cases} = result.data[correctMutation].cases;
            const filteredCases = cases.filter(item => item.caseId === caseId);

            if (filteredCases && filteredCases.length > 0) {
              const [requestedCase] = filteredCases;
              resolve(requestedCase);
            } else {
              reject('case-not-found');
            }
          } else {
            reject('cannot-load-mutations');
          }
        })
        .catch(() => {
          reject('cannot-query');
        });
    });
  }

const [showPopup, setShowPopup] = useState(false)
  useEffect(() => {
    setLoading(true);
    getCaseDetail(caseId)
      .then(requestedCase => {
        console.log('Case details loaded correctly ---> ', requestedCase);
        if(requestedCase?.type === 'REG_TRANSFER' || requestedCase?.type === 'TAKEOVER') {
          setShowPopup(!requestedCase?.draftAsJson?.includes('signValue'))
        }
        setLoading(false);
        setCaseDetails(requestedCase);
      })
      .catch(error => {
        console.log('ERROR: ', error);
      })
    // eslint-disable-next-line
  }, [caseId]);
  const getLayout = () => {
    try {

      if (!loading && caseDetails) {
        if (!caseDetails.type && !caseDetails.draftAsJson) {
          return (
            <div>ERROR NO CONTENT</div>
          )
        }

        const {type, draftAsJson} = caseDetails;
        console.log(type,'type')
        let payload = JSON.parse(draftAsJson);
        if (typeof payload !== 'object') {
          payload = JSON.parse(payload)
        }
        const {currentStep = null} = payload;

        if(!('signValue' in payload) && (type === 'REG_TRANSFER' || type === 'TAKEOVER')) {
          Object.keys(payload).forEach(function(key) {
            if(key !== 'bollettaRecapitoTipo' && key !== 'bollettaAddebitoBancario'  && key !== 'bollettaOnlineAttiva' && key !== 'tipoIntestatario' && key !== 'inQualitaDi' && key !== 'ownerStatus' && key !== 'tipo' && key !== 'tipologiaUsoDomestica'&& key !== 'tipologiaUsoNonDomestica' && key !== 'fisicaSesso' && key !== 'ownerOther') {
              return payload[key] = ""
            }
          })
        }
        console.log('----> PAYLOAD: ', payload);

        return (
          <div>
            {(type === 'REG_TRANSFER' || type === 'TAKEOVER' || type === 'SEWER_CONNECTION' || type === 'LEAK_PROTECTION' || type === 'AQUEDUCT_CONNECTION' || type === "BANK_DOMICILIATION") ? <CaseGenerator
              type={type}
              initialValues={{
                ...payload,
                caseId: caseId,
              }}
              signDigital={role !== 'MUNICIPAL_OPERATOR' ? true : false} // this is mandatory if you want custom success modal
              successModalCustom={
                (props) => digitalizzazioneCustomModalSuccess({t:t,content: "cases.digitalization.success", ...props})
              }
              excludeSteps={role === 'MUNICIPAL_OPERATOR' ? [9]: []}
              currentStep={!('signValue' in payload) ? 0 : currentStep}
            /> :  <CaseGenerator
              type={type}
              initialValues={{
                ...payload,
                caseId: caseId,
              }}
              currentStep={!('signValue' in payload) && (type === 'REG_TRANSFER' || type === 'TAKEOVER') ? 0 : currentStep}
            /> }
          </div>
        )
      }
    } catch (e) {

      return (
        <div style={{height: "1000px"}}>
          <Modal
            show={true}
            onClose={() => { history.push('/view-cases')} }
            description={t("caseDetail.error.notLoad.case")}
            type="link"
            linkTitle={t("selfread.add.goBack")}
            to= {"/view-cases"}
          />
        </div>
      )
    }


    return null;
  }
  return (<div>
    <div className="CaseDetailPage" data-testid="CaseDetailPage">
      {loading ? (<div style={{height: '50vh'}}><Loader /></div>) :(showPopup?<div><Modal
        show={showPopup}
        onClose={() => setShowPopup(false)}
        description={t("list_case_not_completed")}
        type={"button"}
        onFirstClick={() => setShowPopup(false)}
        linkTitle={t("common.hoCapito")}
      /></div> :getLayout())}
    </div>
  </div>)
};

CaseDetailPage.propTypes = {};

export default CaseDetailPage;
